import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./NewHeader.css";
import { faAddressCard, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import {
  faGithub,
  faInstagram,
  faLinkedin,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import ReactGA from "react-ga4";

export default function NewHeader() {
  const [isVisible, setIsvisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const windowWidth = useRef(window.innerWidth);  

  const [shouldShowNavbar, setShouldShowNavbar] = useState(false);

  const headerSocials = [
    {
      icon: faTwitter,
      link: "https://twitter.com/saboor_x",
    },
    {
      icon: faInstagram,
      link: "https://instagram.com/saboor.dev",
    },
    {
      icon: faLinkedin,
      link: "https://www.linkedin.com/in/saboor7/",
    },
    {
      icon: faGithub,
      link: "https://github.com/Sabooralt",
    },
  ];

  const handleScroll = useRef(() => {
    const scrolled = window.scrollY;
    const threshold = 500; // Adjust as needed

    if (scrolled > threshold) {
      setShouldShowNavbar(true);
    } else {
      setShouldShowNavbar(false);
    }
  }).current;

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden"; // Hide overflow when isOpen is true
    } else {
      document.body.style.overflow = "auto"; // Show overflow when isOpen is false
    }

    return () => {
      document.body.style.overflow = "auto"; // Reset overflow style when component unmounts
    };
  }, [isOpen]);

  const handleisOpen = () => {
    setIsOpen(!isOpen);
    ReactGA.event({
      category: "Button",
      action: "Click",
      label: "Menu Button Click",
    });
  };

  const navItems = [
    { title: "Home", index: "01", push: "#" },
    { title: "About", index: "02", push: "#about" },
    { title: "Expertise", index: "03", push: "#expertise" },
    { title: "Work", index: "04", push: "#projects" },
    { title: "Work Preview", index: "05", push: "#project-preview" },
    { title: "Contact", index: "07", push: "#footer" },
  ];

  return (
    <>
      <AnimatePresence>
        {isOpen && windowWidth.current <= 687 && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3 }}
            exit={{ opacity: 0 }}
            className="header_background"
          ></motion.div>
        )}
      </AnimatePresence>
      <AnimatePresence>
        <motion.div
          className="new_header"
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: shouldShowNavbar ? 1 : 0, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.3 }}
          style={{
            backdropFilter:
              isOpen && windowWidth.current <= 687 ? "" : "blur(0.5rem)",
            background:
              isOpen && windowWidth.current <= 687
                ? "transparent"
                : "rgba(0, 0, 0, 0.589)",
          }}
        >
          <div className="header-heading">
            <h1>Saboor</h1>
          </div>
          <div className="nav-buttons d-flex">
            {windowWidth.current >= 687 && (
              <div className="lets_talk">
                <a href="#footer">
                  <motion.button
                    onMouseEnter={() => setIsvisible(true)}
                    onMouseLeave={() => setIsvisible(false)}
                    className="lets_talk_button"
                    whileTap={{ scale: 0.96, transition: { duration: 0.1 } }}
                  >
                    <motion.span
                      initial={{
                        x: -10,
                        opacity: 0,
                      }}
                      animate={{
                        x: isVisible ? 0 : -10,
                        opacity: isVisible ? 1 : 0,
                      }}
                      transition={{ duration: 0.3 }}
                      className="arrow_button"
                    >
                      <FontAwesomeIcon icon={faArrowRight} />
                    </motion.span>
                    Let's Talk {!isVisible && "•"}
                  </motion.button>
                </a>
              </div>
            )}

            <div className="menu">
              <motion.button
                className="menu_button"
                whileTap={{ scale: 0.96, transition: { duration: 0.1 } }}
                transition={{ duration: 0.1 }}
                onClick={handleisOpen}
                style={{
                  width: windowWidth.current <= 687 ? "fit-content" : "11em",
                  padding: windowWidth.current <= 687 ? "15px" : "",
                  borderRadius: windowWidth.current <= 687 ? "50%" : "",
                }}
              >
                {windowWidth.current >= 687 && (
                  <div
                    className="d-flex flex-column"
                    style={{
                      position: "relative",
                      top: "50%",
                    }}
                  >
                    <motion.span
                      className="menu_text"
                      animate={{ opacity: isOpen ? 0 : 1, y: isOpen ? -20 : 0 }}
                      transition={{ duration: 0.3, ease: [0.4, 0, 0.1, 1] }}
                    >
                      Menu
                    </motion.span>
                    <motion.span
                      className="menu_text"
                      animate={{
                        opacity: isOpen ? 1 : 0,
                        y: isOpen ? -24 : 50,
                      }}
                      transition={{ duration: 0.3, ease: [0.4, 0, 0.1, 1] }}
                    >
                      Close
                    </motion.span>
                  </div>
                )}

                <span
                  className="ml-2 button_colon"
                  style={{
                    transform: !isOpen ? "" : "rotate(90deg)",
                    marginLeft: windowWidth.current <= 687 ? "0" : "5px,",
                  }}
                >
                  ••
                </span>
              </motion.button>
            </div>
          </div>

          <div className="header_open position-absolute d-flex flex-column">
            <AnimatePresence>
              {isOpen && (
                <motion.div
                  initial={{
                    y: 100,
                    opacity: 0,
                    rotate: 15,
                  }}
                  animate={{ y: 0, opacity: 1, rotate: 0 }}
                  exit={{ y: 100, opacity: 0, rotate: 15 }}
                  transition={{ duration: 0.3 }}
                  className="header_items_open"
                >
                  {navItems.map((items, index) => (
                    <motion.a
                      href={items.push}
                      key={index}
                      initial={{ x: -20, opacity: 0 }}
                      whileInView={{ x: 0, opacity: 1 }}
                      transition={{ duration: 0.2, delay: index * 0.1 }}
                      exit={{ x: -20, opacity: 0 }}
                      className="w-100 h_open_items d-flex justify-content-between cursor-pointer"
                      onClick={() => setIsOpen(false)}
                    >
                      <span>{items.title}</span>
                      {/*  <spna>•</spna>  */}
                      <span className="arrow_icon_open">
                        <FontAwesomeIcon icon={faArrowRight} />
                      </span>
                    </motion.a>
                  ))}
                </motion.div>
              )}
            </AnimatePresence>
            <AnimatePresence>
              {isOpen && windowWidth.current <= 687 && (
                <motion.a
                  href="#footer"
                  initial={{
                    y: 200,
                    opacity: 0,
                    rotate: 15,
                  }}
                  animate={{ y: 0, opacity: 1, rotate: 0 }}
                  exit={{ y: 200, opacity: 0, rotate: 15 }}
                  transition={{ duration: 0.3 }}
                  className="lets_talk_item"
                >
                  <motion.div
                    initial={{ x: -20, opacity: 0 }}
                    whileInView={{ x: 0, opacity: 1 }}
                    transition={{ duration: 0.2, delay: 0.4 }}
                    exit={{ x: -20, opacity: 0 }}
                    onClick={() => setIsOpen(false)}
                    className="w-100 d-flex justify-content-between align-items-center"
                  >
                    <span>LET'S TALK</span>
                    <FontAwesomeIcon icon={faAddressCard} />
                  </motion.div>
                </motion.a>
              )}
            </AnimatePresence>
            <AnimatePresence>
              {isOpen && windowWidth.current <= 687 && (
                <motion.div
                  initial={{
                    y: 300,
                    opacity: 0,
                    rotate: -15,
                  }}
                  animate={{ y: 0, opacity: 1, rotate: 0 }}
                  exit={{ y: 300, opacity: 0, rotate: -15 }}
                  transition={{ duration: 0.3 }}
                  className="socials_item"
                >
                  <motion.div
                    initial={{ x: -20, opacity: 0 }}
                    whileInView={{ x: 0, opacity: 1 }}
                    transition={{ duration: 0.2, delay: 0.4 }}
                    exit={{ x: -20, opacity: 0 }}
                    onClick={() => setIsOpen(false)}
                    className="w-100 d-flex justify-content-between"
                  >
                    {headerSocials.map((item, index) => (
                      <motion.a
                        href={item.link}
                        whileHover={{ scale: 1.1 }}
                        transition={{ duration: 0.1 }}
                        className="item_social"
                      >
                        <FontAwesomeIcon icon={item.icon} />
                      </motion.a>
                    ))}
                  </motion.div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </motion.div>
      </AnimatePresence>
    </>
  );
}
